const usersPath = '/users';
export default usersPath;
